import { useContext, useState } from "react";
import Saidbar from "./component/Saidbar";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

import IntegrationAdd from "./page/Integration_add";
import IntegrationList from "./page/Integration_list";
import IntegrationDashboard from "./page/Integration_dashboard";
import ProductsCatalog from "./page/ProductsCatalog";
import OrderTracking from "./page/OrderTracking";
import LivraisonAdd from "./page/Livraison/Livraison_add";
import LivraisonList from "./page/Livraison/Livraison_list";
import SubscriptionDashboard from "./page/subscriptions/SubscriptionDashboard";
import SubscriptionList from "./page/subscriptions/SubscriptionList";
import TeamUsersList from "./page/User/TeamUsersList.jsx";
import TeamAddUser from "./page/User/TeamAddUser.jsx";
import ClientsDashboard from "./page/Clients/pages/clients/ClientsDashboard.jsx";
import ClientsList from "./page/Clients/pages/clients/ClientsList.jsx";
import ClientAdd from "./page/Clients/pages/clients/ClientAdd.jsx";
import ClientScoring from "./page/Clients/pages/clients/ClientScoring.jsx";


import OrdersDashboard from "../commerçant/page/orders/pages/orders/OrdersDashboard.jsx";
import PendingOrders from "../commerçant/page/orders/pages/orders/PendingOrders";
import DeliveryDispatch from "../commerçant/page/orders/pages/orders/DeliveryDispatch";
import DeliveryPartners from "../commerçant/page/orders/pages/settings/DeliveryPartners";
import AddOrders from "./page/orders/pages/orders/AddOrders.jsx";
import MaintenancePage from "./MaintenancePage.jsx";
import IntegrationState from "./page/IntegrationState.jsx";
import DeliveryConnect from "./page/Livraison/DeliveryConnect.jsx";
import AllOrdersPage from "./page/orders/pages/orders/AllOrdersPage.jsx";
import UploadData from "./page/orders/pages/orders/UploadData.jsx";

import AdminMarketplaceDashboard from "./page/admin-marketplace/pages/AdminMarketplaceDashboard.jsx";
import AdminMarketplaceOffers from "./page/admin-marketplace/pages/AdminMarketplaceOffers.jsx";
import AdminMarketplaceCollaborations from "./page/admin-marketplace/pages/AdminMarketplaceCollaborations.jsx";
import AdminMarketplaceWallet from "./page/admin-marketplace/pages/AdminMarketplaceWallet.jsx";
import AdminMarketplaceCommissions from "./page/admin-marketplace/pages/AdminMarketplaceCommissions.jsx";
import AdminMarketplaceInvoices from "./page/admin-marketplace/pages/AdminMarketplaceInvoices.jsx";
import AdminMarketplaceMessaging from "./page/admin-marketplace/pages/AdminMarketplaceMessaging.jsx";
import AdminMarketplaceNotifications from "./page/admin-marketplace/pages/AdminMarketplaceNotifications.jsx";
import AdminMarketplaceAuditLogs from "./page/admin-marketplace/pages/AdminMarketplaceAuditLogs.jsx";
import SettingsPage from "./page/settings/SettingsPage.jsx";


/* ================================================================
   PERMISSION GUARD — redirects if child user lacks the permission
================================================================ */
function PermGuard({ permission, userPermissions, children }) {
  if (!permission || !userPermissions) return children;
  if (userPermissions.includes("*")) return children;
  if (userPermissions.includes(permission)) return children;
  // redirect to settings (always accessible) to avoid redirect loops
  return <Navigate to="/settings" replace />;
}

const AppCommercant = () => {
  const [collapsed, setCollapsed] = useState(false);

  // user/permissions déjà chargés et normalisés par AuthContext (voir
  // context/AuthContext.jsx::normalizePermissions) — PrivateRoute garantit
  // que ce composant n'est monté qu'une fois loading=false et user non nul,
  // plus besoin d'un second appel getCurrentUser() ici (c'était une source
  // d'appel réseau dupliqué + de warning ESLint sur l'effet async).
  const { user } = useContext(AuthContext);

  if (!user) return null;

  if (user.status === "INACTIVE") {
    return (<MaintenancePage />);
  }

  const perms = Array.isArray(user.permissions) ? user.permissions : [];

  return (
  <BrowserRouter>
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 transition-colors">

      {/* Sidebar */}
      <Saidbar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        userPermissions={perms}
      />

      {/* Main content */}
      <div
        className={`
          transition-all duration-300
          ${collapsed ? "md:pl-20" : "md:pl-72"}
        `}
      >
        {/* <Nav /> */}
        <main className="p-4 md:p-6">
                <Routes>
                    <Route path="/management/orders/dashboard" element={<PermGuard permission="orders.view" userPermissions={perms}><OrdersDashboard/></PermGuard>}/>
                    <Route path="/management/orders/pending" element={<PermGuard permission="orders.view" userPermissions={perms}><PendingOrders/></PermGuard>}/>
                    <Route path="/management/orders/delivered" element={<PermGuard permission="orders.view" userPermissions={perms}><DeliveryDispatch/></PermGuard>}/>
                    <Route path="/management/orders" element={<PermGuard permission="orders.view" userPermissions={perms}><AllOrdersPage/></PermGuard>}/>
                    <Route path="/management/tracking" element={<PermGuard permission="orders.view" userPermissions={perms}><OrderTracking/></PermGuard>}/>
                    <Route path="/management/orders/add" element={<PermGuard permission="orders.assign" userPermissions={perms}><AddOrders/></PermGuard>}/>
                    <Route path="/management/orders/add_data" element={<PermGuard permission="orders.assign" userPermissions={perms}><UploadData/></PermGuard>}/>

                        <Route path="/settings" element={<SettingsPage />} />
                        <Route path="/settings/delivery-partners" element={<DeliveryPartners />} />

                    <Route path="/integrations/add" element={<PermGuard permission="integrations.manage" userPermissions={perms}><IntegrationAdd/></PermGuard>}/>
                    <Route path="/integrations/list" element={<PermGuard permission="integrations.view" userPermissions={perms}><IntegrationList/></PermGuard>}/>
                    <Route path="/integrations/list/*" element={<PermGuard permission="integrations.view" userPermissions={perms}><IntegrationList/></PermGuard>}/>
                    <Route path="/integrations/products" element={<PermGuard permission="integrations.view" userPermissions={perms}><ProductsCatalog/></PermGuard>}/>
                    <Route path="/integration" element={<PermGuard permission="integrations.view" userPermissions={perms}><IntegrationDashboard/></PermGuard>}/>
                    <Route path="/integration/State" element={<PermGuard permission="integrations.view" userPermissions={perms}><IntegrationState/></PermGuard>}/>

                    <Route path="/delivery/add-company" element={<PermGuard permission="*" userPermissions={perms}><LivraisonAdd/></PermGuard>}/>
                    <Route path="/delivery/companies" element={<PermGuard permission="*" userPermissions={perms}><LivraisonList/></PermGuard>}/>
                    <Route path="/delivery/connect/:slug" element={<PermGuard permission="*" userPermissions={perms}><DeliveryConnect /></PermGuard>} />

                    <Route path="/subscriptions/dashboard" element={<SubscriptionDashboard/>}/>
                    <Route path="/subscriptions/list" element={<SubscriptionList/>}/>

                      <Route path="/users/list" element={<PermGuard permission="team.view" userPermissions={perms}><TeamUsersList /></PermGuard>} />
                      <Route path="/users/add" element={<PermGuard permission="team.create" userPermissions={perms}><TeamAddUser /></PermGuard>} />

                                <Route path="/clients/dashboard" element={<ClientsDashboard />} />
                                <Route path="/clients/list" element={<ClientsList/>} />
                                <Route path="/clients/Add" element={<ClientAdd/>} />
                                <Route path="/clients/scoring" element={<ClientScoring />} />

                      <Route path="/admin-marketplace/dashboard" element={<PermGuard permission="offers.view" userPermissions={perms}><AdminMarketplaceDashboard /></PermGuard>} />
                      <Route path="/admin-marketplace/offers" element={<PermGuard permission="offers.view" userPermissions={perms}><AdminMarketplaceOffers /></PermGuard>} />
                      <Route path="/admin-marketplace/collaborations" element={<PermGuard permission="collaborations.view" userPermissions={perms}><AdminMarketplaceCollaborations /></PermGuard>} />
                      <Route path="/admin-marketplace/wallet" element={<PermGuard permission="wallets.view_own" userPermissions={perms}><AdminMarketplaceWallet /></PermGuard>} />
                      <Route path="/admin-marketplace/commissions" element={<PermGuard permission="commissions.view_own" userPermissions={perms}><AdminMarketplaceCommissions /></PermGuard>} />
                      <Route path="/admin-marketplace/invoices" element={<PermGuard permission="invoices.view_own" userPermissions={perms}><AdminMarketplaceInvoices /></PermGuard>} />
                      <Route path="/admin-marketplace/messaging" element={<PermGuard permission="messaging.view_own" userPermissions={perms}><AdminMarketplaceMessaging /></PermGuard>} />
                      <Route path="/admin-marketplace/notifications" element={<PermGuard permission="messaging.view_own" userPermissions={perms}><AdminMarketplaceNotifications /></PermGuard>} />
                      <Route path="/admin-marketplace/audit-logs" element={<PermGuard permission="*" userPermissions={perms}><AdminMarketplaceAuditLogs /></PermGuard>} />


                      <Route path="*" element={
                        !perms || perms.includes("*") || perms.includes("orders.view")
                          ? <OrdersDashboard/>
                          : <Navigate to="/settings" replace />
                      } />
                </Routes>
        </main>
      </div>
    </div>
   </BrowserRouter>

   );
};

export default AppCommercant;
